import { useState } from "react";

import { ISMainContainer, ISBlankContainer, ISSubContainer, 
    SSContainer, SSDataContainer, SSSliderWrapper, SSSliderLeftBar, SSSliderBall } from "../../../Styles/VTO/VTOContainers";
import { ISBackButton, SSHiddenSlider } from "../../../Styles/VTO/VTOButtons";
import { SSLabel, SSValue } from "../../../Styles/VTO/VTOTexts";

interface IntensitySelectorProps {
    cheeksValue: number,
    cheeksMin?: number,
    cheeksMax?: number,
    isCheeksDisabled: boolean,
    onCheeksIntensityChanged: (value: number) => void,
    lipsValue: number,
    lipsMin?: number,
    lipsMax?: number,
    isLipsDisabled: boolean,
    onLipsIntensityChanged: (value: number) => void,
    onBackButtonTapped: () => void,
}

const IntensitySelector = (props: IntensitySelectorProps) => {

    return (
        <ISMainContainer>
            <ISBlankContainer/>
            <ISBackButton onClick={props.onBackButtonTapped}/>

            <ISSubContainer>
                <SliderSelector
                    label={"Joues"}
                    realMin={0}
                    max={100}
                    realMax={props.cheeksMax ?? 100}
                    step={1}
                    defaultValue={props.cheeksValue}
                    isDisabled={props.isCheeksDisabled}
                    onValueChange={props.onCheeksIntensityChanged}
                    />
                <SliderSelector
                    label={"Lèvres"}
                    realMin={0}
                    max={100}
                    realMax={props.lipsMax ?? 100}
                    step={1}
                    defaultValue={props.lipsValue}
                    isDisabled={props.isLipsDisabled}
                    onValueChange={props.onLipsIntensityChanged}
                    />
            </ISSubContainer>
            <ISBlankContainer/>
        </ISMainContainer>
    );
};

interface SliderSelectorProps {
    label: string,
    max: number,
    realMax: number,
    realMin: number,
    step: number,
    defaultValue: number,
    isDisabled: boolean,
    onValueChange: (value: number) => void
}

const SliderSelector = (props: SliderSelectorProps) => {
    const [value, setValue] = useState<number>(
        Math.floor((props.defaultValue-props.realMin)/(props.realMax-props.realMin)*100)
    )

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Math.min(props.max, Math.max(0, Number(event.target.value)))
        setValue(newValue)
        const realValue = Math.ceil(newValue/100 * (props.realMax-props.realMin) + props.realMin)
        props.onValueChange(realValue)
    }

    const progress = (value / props.max) * 100

    return (
        <SSContainer>
            <SSDataContainer>
                <SSLabel disabled={props.isDisabled}>{props.label}</SSLabel>
                <SSValue disabled={props.isDisabled}>{value}</SSValue>
            </SSDataContainer>
            <SSSliderWrapper disabled={props.isDisabled} >
                <SSSliderLeftBar width={progress} />
                <SSSliderBall style={{ left: `calc(${progress}% - 10px)`}} disabled={props.isDisabled} />
                <SSHiddenSlider
                    type="range"
                    min={0}
                    max={props.max}
                    step={props.step}
                    value={value}
                    disabled={props.isDisabled}
                    onChange={handleChange}
                />
            </SSSliderWrapper>
        </SSContainer>
    )
}

export default IntensitySelector;